import { DateCalendar, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./calendar-widget.css";
import {
  updateCalendarWidgetDate,
  updateDateSelectionStatus,
} from "../../features/calendarWidgetSlice";
import { Button } from "@mui/material";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import "../../components/navigation/Nav-btn-group.css";
import { useNavigate, useSearchParams } from "react-router-dom";

const CalendarWidget = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isDateSelected, setIsDateSelected] = useState(false);

  const handleDateChange = (newDate) => {
    var date = new Date(newDate);
    var finalAppointmentDate = date.toDateString();
    dispatch(updateCalendarWidgetDate({ finalAppointmentDate }));
    setIsDateSelected(true);
  };

  const configNextNav = () => {
    if (isDateSelected) {
      navigate(`/booking-details`);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <div className="calendar__widget">
        <div className="calendar__widget__header">
          <h1>Select appointment date</h1>
        </div>
        <DateCalendar
          onChange={(newValue) => handleDateChange(newValue.$d)}
          disablePast
        />
        <div className="navigation-btn__group">
          <Button
            color="primary"
            variant="outlined"
            className="navigation__btn"
            endIcon={<NavigateNextIcon />}
            onClick={configNextNav}
          >
            Next
          </Button>
        </div>
      </div>
    </LocalizationProvider>
  );
};

export default CalendarWidget;
